import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@models/core/model-factory';
import { CompanyDocument } from '@models/documents/company-document.model';
import { Node } from '@models/documents/directory/node.model';
import { EmployeeDocument } from '@models/documents/employee-document.model';
import { SigningTemplate } from '@models/documents/signing-template.model';
import { TrainingProgramRecordFile } from '@models/documents/training-program-record-file.model';

@Injectable()
export class DocumentsV2Resolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'node',
            production: {
                find: (id: number): Promise<Node> => {
                    return Node.with(['source']).find(id);
                },
            },
        },
        {
            className: 'companyDocument',
            production: {
                find: (id: number): Promise<CompanyDocument> => {
                    return CompanyDocument.with([
                        'file',
                        'file.uploadedBy',
                        'signingTemplate',
                        'signingTemplate.slots',
                        'signingTemplate.slots.assignee',
                        'signingTemplate.slots.customFieldAssignments',
                        'documentTags',
                        'employeesWithPendingAssignments',
                    ]).find(id);
                },
            },
        },
        {
            className: 'signingTemplate',
            production: {
                find: (id: number, route?: ActivatedRouteSnapshot): Promise<SigningTemplate> => {
                    return SigningTemplate.param('companyDocument', route?.params.companyDocument).find(id);
                },
            },
        },
        {
            className: 'employeeDocument',
            production: {
                find: (id: number, route?: ActivatedRouteSnapshot): Promise<EmployeeDocument> => {
                    return EmployeeDocument.param('employee', route?.params.employee)
                        .with(['roles', 'employee'])
                        .find(id);
                },
            },
        },
        {
            className: 'trainingProgramRecordFile',
            production: {
                find: (id: number): Promise<TrainingProgramRecordFile> => {
                    return TrainingProgramRecordFile.with(['file']).find(id);
                },
            },
        },
    ]);
}
